/// <reference types="vite/client" />

export type Language = 'de' | 'en' | 'es';

/**
 * Environment Configuration
 * Zentrale Verwaltung aller Environment Variables
 */
export const env = {
  // App
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  mode: import.meta.env.MODE,
  
  // Language
  language: (import.meta.env.VITE_LANGUAGE || 'es') as Language,
  
  // API (aktuell nicht genutzt, für zukünftige Erweiterungen)
  apiUrl: import.meta.env.VITE_API_URL || 'https://api.samebi.net',
  
  // Analytics
  gaTrackingId: import.meta.env.VITE_GA_TRACKING_ID || '',
  
  // Base URL
  baseUrl: import.meta.env.VITE_BASE_URL || '',
} as const;

/**
 * Get language from URL hostname
 */
export const getLanguageFromUrl = (): Language => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('burnout-test.samebi.net')) return 'de';
    if (hostname.includes('burnout-check.samebi.net')) return 'en';
    if (hostname.includes('test-burnout.samebi.net')) return 'es';
  }
  return env.language;
};





